import config from "../config";
import getAccessToken from "./auth";

export const createDraftNotes = async (meetingId: string, transcription: string, additionalNotes: string, smartTemplateId: number, smartTemplateCodedId: string) => {
  const accessToken = await getAccessToken();
  const apiBaseUrl = config.apiEndpoint;
  const response = await fetch(`${apiBaseUrl}/api/transcripts/create-draft-notes`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${accessToken}`,
      "x-functions-key": config.functionKey
    },
    body: JSON.stringify({
      MeetingId: meetingId,
      Transcription: transcription,
      AdditionalNotes: additionalNotes,
      SmartTemplateId: smartTemplateId,
      SmartTemplateCodedId: smartTemplateCodedId
    }),
  });
  if (response.status === 201 ||  (response.status === 200))  {
    const result = await response.json();
    return result;
  } else {
    const errorText = await response.text();
    throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
  }
};

export const fetchTranscript = async (userId: string, chatId: string): Promise<string> => {
  const accessToken = await getAccessToken();
  const apiBaseUrl = config.apiEndpoint;
  const response = await fetch(`${apiBaseUrl}/api/user/${userId}/chat/${chatId}/transcripts`, {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${accessToken}`,
      "Content-Type": "application/json",
      "x-functions-key": config.functionKey
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch transcript: ${response.statusText}`);
  }

  return response.text();
};

